import $ from 'jquery';
import Swiper from 'swiper';
import { Grid } from 'swiper/modules';

$($ => {
	let swiper = new Swiper('.related-posts-alt-carousel', {
		slidesperView: 1,
		spaceBetween: 24,
		loop: false,
		breakpoints: {
			'@0.75': {
				slidesPerView: 1,
			},
			'@1.25': {
				slidesPerView: 2,
			},
		},
		modules: [Grid],
	});
});
